import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=686bf4ff&"
import script from "./Pie.vue?vue&type=script&lang=js&"
export * from "./Pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports